import { HttpClient } from '@angular/common/http';

/** A page of a paged autocomplete (users only so far). */
export interface AutocompletePage {
  offset: number;
  limit: number;
}

/**
 * Search request of the autocomplete endpoint, for companies or users. With
 * a page the API answers up to limit + 1 users: one more means another page.
 */
export const searchAutocomplete = <T>(
  http: HttpClient,
  path: string,
  requestType: string,
  needle: string,
  page?: AutocompletePage
) =>
  http.post<T[]>(path, {
    method: 'autocomplete',
    data: {
      requestType,
      needle,
      ...page,
    },
  });
